module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }